export default {
  txz: 'Suitcase stand',//提箱站
  ggcs:'Specification parameters',//规格参数
  ckg:'Dimensions',//长宽高
  zztj:'Load capacity volume',//载重体积
  zzlck:'Load reference',//装载量参考
  txrq: 'Date of suitcase',//提箱日期
  syxs:'Remaining container number',//剩余箱数
  qkxzy:'Empty container resources',//取空箱资源
  xs:'Container number',//箱数
}
